// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2AzbY","inputWrap":"Table_inputWrap__Ps3fi","col":"Table_col__24q4w","bmiTooltip":"Table_bmiTooltip__1cj8a"};